import maListitem from './modules/item'
import maListcounter from './modules/counter'
import maListavatar from './modules/avatar'

/**
 * @module
 * @name List
 */
export default {
  name: 'List',
  components: {
    maListitem,
    maListcounter,
    maListavatar
  },

  /**
   * @property {String} type Type of list. Could be item, counter, avatar.
   * @property {Object} listData Object which contains all the list information
   */
  props: {
    type: {
      type: String,
      required: true
    },
    listData: {
      type: Object,
      required: true
    }
  },

  /**
   * @property {String} listType Returns complete list name.
   * @property {String} listClasses Return concat list and list type.
   */
  computed: {
    listType () {
      return 'maList' + this.type
    },
    listClasses () {
      return (
        `list--${this.type} `
      )
    }
  }
}
